import type { NavLinkItem } from './types';

/** Default support phone (same source as Contact page). */
export const DEFAULT_PHONE =
  process.env.REACT_APP_SUPPORT_PHONE ?? '+1 470-283-5994';

/** Default navigation links for the header. */
export const DEFAULT_NAV_LINKS: NavLinkItem[] = [
  { href: 'about', label: 'About Us', isSection: true, icon: 'mdi:information-outline' },
  { href: 'services', label: 'Services', isSection: true, icon: 'mdi:car-side' },
  { href: 'video', label: 'How It Works', isSection: true, icon: 'mdi:play-circle-outline' },
  { href: 'quote', label: 'Request a Quote', isSection: true, icon: 'mdi:file-document-outline' },
  { href: 'reviews', label: 'Reviews', isSection: true, icon: 'mdi:star' },
  { href: 'carrier', label: 'Carrier Registration', isSection: true, icon: 'mdi:clipboard-account-outline' },
  { href: 'faq', label: 'FAQ', isSection: true, icon: 'mdi:help-circle-outline' },
  { href: '/contact', label: 'Contact', isSection: false, icon: 'mdi:email-outline' },
];
